import IExtension from "./IExtension";
import {Naja} from "naja";

/**
 * Keep file input value on snippet redraw
 */
export default class KeepFileInputValueExtension implements IExtension {
    private readonly inputs: Map<string, HTMLInputElement> = new Map();

    initialize(naja: Naja): void {

        naja.snippetHandler.addEventListener('beforeUpdate', e => {
            $(e.detail.snippet).find('input[type="file"]:not([data-not-keep-input-value])').each((i, input: HTMLInputElement) => {
                this.inputs.set(input.id, input);
            })
        });

        naja.snippetHandler.addEventListener('afterUpdate', e => {
            $(e.detail.snippet).find('input[type="file"]:not([data-not-keep-input-value])').each((i, input: HTMLInputElement) => {
                if (!this.inputs.has(input.id)) {
                    return;
                }

                const originalInput = this.inputs.get(input.id);

                if (!originalInput.files.length) {
                    return
                }

                input.replaceWith(originalInput);
                console.log(`KeepFileInputValueExtension: keep file input #${input.id}`);
            });

            this.inputs.clear();
        });

    }
}
